import '../../styles/templates/pages/page.studios-faqs.scss';
